export default "__VITE_ASSET__DNoGecVr__"